export const getGridFormingCertificateUploadPath = (matrixType?: number) =>
  `/upload-grid-forming-certificate${matrixType ? `?matrixType=${matrixType}` : ""}`;
